// extracted by mini-css-extract-plugin
export var arrow = "MobileSection-module--arrow--a5beb";
export var count = "MobileSection-module--count--b7ead";
export var editButton = "MobileSection-module--editButton--1dc81";
export var fadeInAnimation = "MobileSection-module--fadeInAnimation--81a27";
export var icon = "MobileSection-module--icon--2adbc";
export var item = "MobileSection-module--item--f9ca2";
export var list = "MobileSection-module--list--039c5";
export var name = "MobileSection-module--name--5476c";
export var plus = "MobileSection-module--plus--b8100";
export var sectionTitle = "MobileSection-module--sectionTitle--e3bdb";
export var show = "MobileSection-module--show--b50b6";
export var tab = "MobileSection-module--tab--60abd";